module.exports = __webpack_public_path__ + "img/ford.cbd4baa6.webp";